import { inject, IterableDiffers } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { isConstructor } from '@core/shared/utils';
import 'reflect-metadata';
import { buildDynamicFormGroup } from './build-controls';
import * as i0 from "@angular/core";
export let DynamicFormBuilder = /*#__PURE__*/(() => {
  class DynamicFormBuilder extends FormBuilder {
    constructor() {
      super(...arguments);
      // some logic of our dynamicFormGroup requires diffing.
      // They will use this factory to create ng IterableDiffers.
      this.diffFactory = inject(IterableDiffers);
    }
    // rootFormGroup<T = Record<string, unknown>>(classType: ClassConstructor<T> | null,controlsConfig?: any,options?: any): DynamicFormGroup<T> {
    // 	// console.warn('TODO: creating legacy rootFormGroup')
    // 	return this.dynamicGroup(classType, controlsConfig, options) as any
    // }
    group(factoryModelOrControls, controlsConfig, options) {
      if (!isConstructor(controlsConfig)) {
        return super.group(factoryModelOrControls);
      } else {
        if (typeof options.validators === 'function') throw new Error('options.validators must not be a function, pass array of validators!');
        return this.dynamicGroup(factoryModelOrControls, controlsConfig, options);
      }
    }
    dynamicGroup(factoryModel, formStructureInput, options) {
      return buildDynamicFormGroup(this, {
        type: factoryModel
      }, formStructureInput, options);
    }
    /**
     * NOTE: There is no method to create dynamicFormArrays cause these can only ever be children of a DynamicFormGroup.
     * For that reason, the factory for these is located in DynamicFormGroup class.
     */
    array(controlsConfig, validatorOrOpts, asyncValidator) {
      return super.array(controlsConfig, validatorOrOpts, asyncValidator);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵDynamicFormBuilder_BaseFactory;
        return function DynamicFormBuilder_Factory(__ngFactoryType__) {
          return (ɵDynamicFormBuilder_BaseFactory || (ɵDynamicFormBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(DynamicFormBuilder)))(__ngFactoryType__ || DynamicFormBuilder);
        };
      })();
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DynamicFormBuilder,
        factory: DynamicFormBuilder.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DynamicFormBuilder;
})();